module.exports = __webpack_public_path__ + "media/images/bnr-insta-feed-detailed-sm-78af2dfa03e60b942d940dff82adf2ee.png";